/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Archetype_SecondaryInputs */

const en_deep_match_archetype_secondary = /** @type {(inputs: Deep_Match_Archetype_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary`)
};

const de_deep_match_archetype_secondary = /** @type {(inputs: Deep_Match_Archetype_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary`)
};

const fr_deep_match_archetype_secondary = /** @type {(inputs: Deep_Match_Archetype_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary`)
};

const es_deep_match_archetype_secondary = /** @type {(inputs: Deep_Match_Archetype_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary`)
};

const it_deep_match_archetype_secondary = /** @type {(inputs: Deep_Match_Archetype_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary`)
};

const nl_deep_match_archetype_secondary = /** @type {(inputs: Deep_Match_Archetype_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary`)
};

const pl_deep_match_archetype_secondary = /** @type {(inputs: Deep_Match_Archetype_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary`)
};

const fi_deep_match_archetype_secondary = /** @type {(inputs: Deep_Match_Archetype_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary`)
};

const da_deep_match_archetype_secondary = /** @type {(inputs: Deep_Match_Archetype_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary`)
};

const sv_deep_match_archetype_secondary = /** @type {(inputs: Deep_Match_Archetype_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary`)
};

/**
* | output |
* | --- |
* | "Secondary" |
*
* @param {Deep_Match_Archetype_SecondaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_archetype_secondary = /** @type {((inputs?: Deep_Match_Archetype_SecondaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Archetype_SecondaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_archetype_secondary(inputs)
	if (locale === "fr") return fr_deep_match_archetype_secondary(inputs)
	if (locale === "es") return es_deep_match_archetype_secondary(inputs)
	if (locale === "it") return it_deep_match_archetype_secondary(inputs)
	if (locale === "nl") return nl_deep_match_archetype_secondary(inputs)
	if (locale === "pl") return pl_deep_match_archetype_secondary(inputs)
	if (locale === "fi") return fi_deep_match_archetype_secondary(inputs)
	if (locale === "da") return da_deep_match_archetype_secondary(inputs)
	if (locale === "sv") return sv_deep_match_archetype_secondary(inputs)
	return en_deep_match_archetype_secondary(inputs)
});